/**
 * Capacitor native platform initialization
 * Only runs when the app is inside a native iOS/Android shell.
 * No-ops gracefully on web.
 */

import { Capacitor } from '@capacitor/core';
import { StatusBar, Style } from '@capacitor/status-bar';
import { SplashScreen } from '@capacitor/splash-screen';
import { Keyboard } from '@capacitor/keyboard';
import { App } from '@capacitor/app';
import { initPushNotifications } from './push-notifications';

export const isNative = Capacitor.isNativePlatform();

export async function initCapacitor() {
  if (!isNative) return;

  // Dark status bar (light text on dark background)
  try {
    await StatusBar.setStyle({ style: Style.Dark });
    await StatusBar.setBackgroundColor({ color: '#0A0A0A' });
  } catch {}

  // Hide splash screen after app renders
  try {
    await SplashScreen.hide({ fadeOutDuration: 300 });
  } catch {}

  // Keyboard: scroll instead of resize on iOS
  try {
    Keyboard.setAccessoryBarVisible({ isVisible: false });
  } catch {}

  // Handle back button on Android (navigate back in SPA)
  App.addListener('backButton', ({ canGoBack }) => {
    if (canGoBack) {
      window.history.back();
    } else {
      App.exitApp();
    }
  });

  // Handle deep links (vauren://path or https://vauren.com/path)
  App.addListener('appUrlOpen', ({ url }) => {
    const path = new URL(url).pathname;
    if (path) {
      window.location.href = path;
    }
  });

  // Push notifications
  initPushNotifications();
}
